import { api } from './Api';

export const updateWorkspaceConfig = (name: string, value: any, type?: string) => {
  /*
   * We added the /update endpoint because on the BE, the updated object is identified by name (name is unique)
   */
  return api.post(`/workspace_config/update`, {
    name, value, type,
  }).then((res: any) => res.data);
}

export const loadCurrentWorkspaceConfig = () => {
  return api.get(`/workspace_config/current`).then((res: any) => res.data);
}
